export const CROP_DISALLOWED = 'none';
export const CROP_OPTIONAL = 'optional';
export const CROP_REQUIRED = 'required';
export const CROP_INTENTIONS = [CROP_DISALLOWED, CROP_OPTIONAL, CROP_REQUIRED];

export const REQUIRED_CROP_CANCELED = 'required-crop-canceled';
export const API_RESPONSE_BAD_FORMAT = 'BAD_FORMAT';
